import React, { FunctionComponent } from 'react';
import { useI18n } from 'app/components/localization';
import BrandMaterialsLink from 'app/components/materials/BrandMaterialsLink';
import NavigationLink from 'app/components/header/navigation/NavigationLink';

/**
 * A reusable component that renders organization materials links with header navigation items.
 * Should only be used in header.
 */
const BrandMaterialsNavigationItems: FunctionComponent = () => {
  const { t } = useI18n();

  return (
    <BrandMaterialsLink>
      {({ materialsUrl, dailyNewsUrl }) => (
        <>
          {materialsUrl && <NavigationLink to={materialsUrl}>{t('daily-news.navigation.materials')}</NavigationLink>}

          {dailyNewsUrl && (
            <NavigationLink to={dailyNewsUrl}>{t('daily-news.navigation.daily-news')}</NavigationLink>
          )}
        </>
      )}
    </BrandMaterialsLink>
  );
};

export default BrandMaterialsNavigationItems;
